<div class="page-footer" fxLayout="row" fxLayoutAlign="space-between center">
  @if (hasBack) {
    <button
      class="primary-btn"
      [disabled]="!hasBack"
      (click)="onBack.emit()"
      fxLayout="row"
      fxLayoutAlign="center center"
      fxLayoutGap="6px"
    >
      <mat-icon svgIcon="arrow-left" />
      <span>Back</span>
    </button>
  } @else {
    <div></div>
  }
  @if (!hideContinue) {
    <button
      class="primary-btn filled-btn"
      (click)="onSubmit.emit()"
      fxLayout="row"
      fxLayoutAlign="center center"
      fxLayoutGap="6px"
      [disabled]="updateCartInProgress"
    >
      <span>Continue</span>
      <mat-icon svgIcon="ss3-arrow-right" />
    </button>
  }
  @if (showScrollToPayment) {
    <button
      class="primary-btn filled-btn no-desktop"
      (click)="onSubmit.emit()"
      fxLayout="row"
      fxLayoutAlign="center center"
      fxLayoutGap="6px"
    >
      <span>Scroll to Payment</span>
      <mat-icon svgIcon="ss3-arrow-right" class="rotate-90" />
    </button>
  }
  <ng-content></ng-content>
</div>
